/* Bella Terra: omit the review app's zero-review aggregate rating. */
(() => {
  document.querySelectorAll('script[type="application/ld+json"][data-product-schema]').forEach((element) => {
    const omitEmptyRating = () => {
      try {
        const product = JSON.parse(element.textContent);
        if (product['@type'] !== 'Product' || !product.aggregateRating) return;
        const count = product.aggregateRating.ratingCount ?? product.aggregateRating.reviewCount;
        if (count == null || String(count).trim() === '' || Number(count) !== 0) return;
        delete product.aggregateRating;
        element.textContent = JSON.stringify(product);
      } catch (_) {
        // Leave unrelated or incomplete structured data untouched.
      }
    };
    new MutationObserver(omitEmptyRating).observe(element, {childList: true, characterData: true, subtree: true});
    omitEmptyRating();
  });
})();
/* End zero-review rating guard. */

(() => {
  const roots = document.querySelectorAll('.bto-apricot-preview:not([data-bto-ready])');
  if (!roots.length) return;

  document.documentElement.classList.add('bto-apricot-document');
  document.body.classList.add('bto-apricot-template');

  const legacyOverlaySelector = [
    
    '#voice-bot-wrapper', '#voice-bot-panel', '#tidio-chat', '#codex-tidio-close',
    '.codex-widget-close', '#zooomysalespop'
  ].join(',');
  const removeLegacyOverlays = () => document.querySelectorAll(legacyOverlaySelector).forEach((element) => {
    if (element.matches('#tidio-chat')) {
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      element.style.setProperty('display', 'none', 'important');
      return;
    }
    element.remove();
  });
  removeLegacyOverlays();
  if (!window.btoProductOverlayObserver) {
    window.btoProductOverlayObserver = new MutationObserver(removeLegacyOverlays);
    window.btoProductOverlayObserver.observe(document.body, { childList: true, subtree: true });
  }

  const isPreview = /(?:[?&]view=bto-[^&]+-preview|[?&]preview_theme_id=)/.test(window.location.search) || Boolean(window.Shopify?.designMode);
  if (isPreview && !document.head.querySelector('meta[data-bto-preview-robots]')) {
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex,nofollow';
    robots.dataset.btoPreviewRobots = 'true';
    document.head.appendChild(robots);
  }

  roots.forEach((root) => {
    root.dataset.btoReady = 'true';
    const currency = root.dataset.currency || 'USD';
    const productName = root.dataset.productTitle || 'Apricot Kernel Oil';
    const productHandle = root.dataset.productHandle || 'apricot-kernel-oil';
    const money = (cents) => {
      const value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
      } catch (_) {
        return `$${value.toFixed(2)}`;
      }
    };

    const gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      const stage = gallery.querySelector('[data-gallery-stage]');
      const stageImage = gallery.querySelector('[data-gallery-image]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const lightbox = root.querySelector('[data-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
      let activeIndex = 0;
      let pointerStart = null;
      let didSwipe = false;

      const setSlide = (index) => {
        activeIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        stageImage.src = thumb.dataset.src;
        stageImage.alt = thumb.dataset.alt || '';
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === activeIndex;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        if (lightboxImage) {
          lightboxImage.src = thumb.dataset.src;
          lightboxImage.alt = thumb.dataset.alt || '';
        }
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setSlide(index)));
      stage?.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        pointerStart = { x: event.clientX, y: event.clientY };
        didSwipe = false;
      });
      stage?.addEventListener('pointerup', (event) => {
        if (!pointerStart || event.pointerType === 'mouse') return;
        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
        didSwipe = true;
        setSlide(activeIndex + (deltaX < 0 ? 1 : -1));
        window.setTimeout(() => { didSwipe = false; }, 0);
      });
      stage?.addEventListener('pointercancel', () => { pointerStart = null; });
      stage?.addEventListener('click', (event) => {
        if (didSwipe) {
          event.preventDefault();
          return;
        }
        if (!lightbox) return;
        lightbox.classList.remove('is-package-preview');
        setSlide(activeIndex);
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      });
      lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
      lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => setSlide(activeIndex - 1));
      lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => setSlide(activeIndex + 1));
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
      document.addEventListener('keydown', (event) => {
        if (!lightbox?.open) return;
        if (lightbox.classList.contains('is-package-preview')) return;
        if (event.key === 'ArrowLeft') setSlide(activeIndex - 1);
        if (event.key === 'ArrowRight') setSlide(activeIndex + 1);
      });
    }

    const form = root.querySelector('.bto-purchase-form');
    if (form) {
      const sizeOptions = [...form.querySelectorAll('[data-size-option]')];
      // Keep both existing gallon variants in one size tile; retain each variant's data and handlers.
      const isGallon = title => /^(?:128(?:\s*(?:fl\.?\s*)?oz)?|(?:1\s*)?gal(?:lon)?)(?:\s+(?:with(?:out)?|wth)\s+pump\.?)?$/i.test((title || '').replace(/\s+/g, ' ').trim());
      const includesPump = title => /(?:with|wth)\s+pump\.?$/i.test(title || '');
      const gallons = sizeOptions.filter(option => isGallon(option.dataset.title));
      if (gallons.length > 1 && !form.querySelector('.bto-gallon-option')) {
        const group = document.createElement('div');
        group.className = 'bto-gallon-option';
        group.style.order = '6';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', '1 gallon — choose with or without pump');
        const heading = document.createElement('strong');
        heading.textContent = '1 gallon';
        group.append(heading);
        gallons[0].before(group);
        gallons.sort((a,b) => Number(includesPump(a.dataset.title)) - Number(includesPump(b.dataset.title))).forEach(option => {
          const label = includesPump(option.dataset.title) ? 'With pump' : 'No pump';
          const status = option.disabled ? 'Sold out' : option.dataset.preorder === 'true' ? 'Preorder' : '';
          option.replaceChildren();
          const name = document.createElement('span');
          name.textContent = label;
          const price = document.createElement('b');
          price.textContent = money(option.dataset.price);
          option.append(name, price);
          if (status) { const note = document.createElement('em'); note.textContent = status; option.append(note); }
          option.setAttribute('aria-label', '1 gallon ' + label.toLowerCase() + ' — ' + money(option.dataset.price) + (status ? ' — ' + status : ''));
          group.append(option);
        });
      }
      const variantInput = form.querySelector('[data-variant-input]');
      const selectedTitle = form.querySelector('[data-selected-title]');
      const selectedReason = form.querySelector('[data-selected-reason]');
      const selectedPrice = form.querySelector('[data-selected-price]');
      const selectedCompare = form.querySelector('[data-selected-compare]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addLabel = form.querySelector('[data-add-label]');
      const formError = form.querySelector('[data-form-error]');
      const dispensing = form.querySelector('[data-dispensing-note]');
      const dispensingTitle = form.querySelector('[data-dispensing-title]');
      const dispensingCopy = form.querySelector('[data-dispensing-copy]');
      const isHydrosol = root.dataset.productKind === 'hydrosol';
      const packageImage = form.querySelector('[data-package-image]');
      const packageButton = form.querySelector('[data-package-enlarge]');
      const sealSlot = form.querySelector('[data-seal-slot]');
      const preorderNote = form.querySelector('[data-preorder-note], [data-gallon-pump-preorder]');
      const preorderCopy = form.querySelector('[data-preorder-copy]');
      const dock = root.querySelector('[data-mobile-dock]');
      const dockSize = dock?.querySelector('[data-dock-size]');
      const dockPrice = dock?.querySelector('[data-dock-price]');
      const dockSubmit = dock?.querySelector('[data-dock-submit]');
      let selected = sizeOptions.find((option) => option.classList.contains('is-selected')) || sizeOptions[0];
      let purchaseType = 'one-time';

      const selectedIsPreorder = () => selected?.dataset.preorder === 'true';
      const selectedPreorderDate = () => selected?.dataset.preorderDate || root.dataset.preorderDate || '';
      const syncPreorderProperty = () => {
        const field = form.querySelector('input[name="properties[Pre-order item]"]');
        if (!field) return;
        field.disabled = !selectedIsPreorder();
        if (selectedIsPreorder()) {
          field.value = selectedPreorderDate() ? `Expected to ship on or after ${selectedPreorderDate()}.` : 'Pre-order: contact Bella Terra for the current dispatch estimate.';
        }
      };

      const updateDispensing = () => {
        const title = (selected.dataset.title || '').replace(/\s+/g, ' ').trim();
        const packageSrc = title === '4 oz'
          ? root.querySelector('[data-gallery-thumb]')?.dataset.src || selected.dataset.image
          : selected.dataset.image;
        if (packageImage) {
          packageImage.closest('[data-package-enlarge]').hidden = !packageSrc;
        }
        if (packageImage && packageSrc) {
          packageImage.src = packageSrc;
          packageImage.alt = `${title} ${productName} packaging`;
        }
        if (isHydrosol && ['2 oz', '4 oz', '8 oz', '16 oz', '32 oz'].includes(title)) {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Fine-mist sprayer included';
          dispensingCopy.textContent = 'Ready for easy face, body, and hair misting.';
        } else if (title === '8 oz' || title === '16 oz') {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Snap cap';
          dispensingCopy.textContent = 'The 8 oz and 16 oz oil bottles use snap caps for controlled dispensing.';
        } else if (title === '4 oz') {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Dropper + pump included';
          dispensingCopy.textContent = 'The bottle is shown with its dropper installed, and the included capped pump beside it. Choose the dropper for precise control or the pump for convenient dispensing.';
        } else if (title === '2 oz') {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Dropper included';
          dispensingCopy.textContent = 'The 2 oz oil bottle comes with a dropper for controlled, precise application.';
        } else if (title === '32 oz') {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Secure cap; no pump included';
          dispensingCopy.textContent = 'A refill-focused size designed for pouring into a smaller everyday bottle.';
        } else if (isGallon(title) && includesPump(title)) {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Gallon pump included';
          dispensingCopy.textContent = 'A practical dispensing option for frequent-use, maker, and studio routines.';
        } else if (isGallon(title)) {
          dispensing.hidden = false;
          dispensingTitle.textContent = 'Gallon without pump';
          dispensingCopy.textContent = 'Choose this option when you already have a compatible dispensing setup.';
        } else {
          dispensing.hidden = true;
        }
      };

      // Let the selected size and price paint before notifying analytics and app listeners.
      // Flush first on another selection or submit so listeners never receive a stale variant.
      let pendingVariantChange = false;
      let variantChangeFrame = 0;
      let variantChangeTimer = 0;
      const flushVariantChange = () => {
        if (variantChangeFrame) cancelAnimationFrame(variantChangeFrame);
        if (variantChangeTimer) clearTimeout(variantChangeTimer);
        variantChangeFrame = 0;
        variantChangeTimer = 0;
        if (!pendingVariantChange) return;
        pendingVariantChange = false;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const queueVariantChange = () => {
        pendingVariantChange = true;
        if (document.visibilityState === 'hidden' || typeof requestAnimationFrame !== 'function') {
          flushVariantChange();
          return;
        }
        if (variantChangeFrame || variantChangeTimer) return;
        variantChangeFrame = requestAnimationFrame(() => {
          variantChangeFrame = 0;
          variantChangeTimer = setTimeout(flushVariantChange, 0);
        });
      };
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') flushVariantChange();
      });
      window.addEventListener('pagehide', flushVariantChange);

      const updatePurchase = () => {
        if (!selected) return;
        const title = (selected.dataset.title || '').replace(/\s+/g, ' ').trim();
        const shortLabel = selected.dataset.shortLabel || title;
        const reason = selected.dataset.reason || '';
        const price = Number(selected.dataset.price || 0);
        const comparePrice = Number(selected.dataset.comparePrice || 0);
        const subPrice = Number(selected.dataset.subscriptionPrice || 0);
        const available = selected.dataset.available === 'true';
        const preorder = selectedIsPreorder();
        const preorderDate = selectedPreorderDate();
        if (preorder) purchaseType = 'one-time';
        const displayedPrice = purchaseType === 'subscription' && subPrice ? subPrice : price;

        const nextVariantId = selected.dataset.variantId || '';
        const variantChanged = variantInput.value !== nextVariantId;
        variantInput.value = nextVariantId;
        selectedTitle.textContent = `${title} ${productName}`;
        selectedReason.textContent = preorder && preorderDate ? `Pre-order · Ships ${preorderDate} or later` : reason;
        selectedPrice.textContent = money(displayedPrice);
        selectedCompare.hidden = purchaseType === 'subscription' || !(comparePrice > price);
        selectedCompare.textContent = comparePrice > price ? money(comparePrice) : '';
        addButton.disabled = !available;
        addLabel.textContent = available
          ? preorder
            ? `Pre-order ${shortLabel} — ${money(displayedPrice)}`
            : `${purchaseType === 'subscription' ? 'Subscribe to' : 'Add'} ${shortLabel} ${purchaseType === 'subscription' ? '—' : 'to cart —'} ${money(displayedPrice)}`
          : `${shortLabel} is sold out`;
        if (sealSlot) sealSlot.hidden = preorder;
        if (preorderNote) preorderNote.hidden = !preorder;
        if (preorderCopy && preorderDate) preorderCopy.textContent = `Expected to ship on or after ${preorderDate}.`;
        if (dockSize) dockSize.textContent = shortLabel;
        if (dockPrice) dockPrice.textContent = money(displayedPrice);
        if (dockSubmit) {
          const arrow = dockSubmit.querySelector('.bto-arrow');
          dockSubmit.textContent = preorder ? 'Pre-order ' : 'Add to cart ';
          if (arrow) dockSubmit.append(arrow);
        }
        syncPreorderProperty();
        updateDispensing();
        if (variantChanged) queueVariantChange();
      };

      sizeOptions.forEach((option) => option.addEventListener('click', () => {
        if (option.disabled) return;
        flushVariantChange();
        selected = option;
        sizeOptions.forEach((item) => {
          const pressed = item === selected;
          item.classList.toggle('is-selected', pressed);
          item.setAttribute('aria-pressed', String(pressed));
        });
        updatePurchase();
      }));

      packageButton?.addEventListener('click', () => {
        const lightbox = root.querySelector('[data-lightbox]');
        const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
        if (!lightbox || !lightboxImage || !packageImage?.src) return;
        lightbox.classList.add('is-package-preview');
        lightboxImage.src = packageImage.src;
        lightboxImage.alt = packageImage.alt || `Selected ${productName} packaging`;
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      });

      const sealEventBelongsToForm = (event) => {
        const element = event?.detail?.element;
        return !element || form.contains(element);
      };
      document.addEventListener('sealsubs:selling_plan_changed', (event) => {
        if (!sealEventBelongsToForm(event)) return;
        purchaseType = selectedIsPreorder() ? 'one-time' : event.detail?.selling_plan_id ? 'subscription' : 'one-time';
        updatePurchase();
      });
      document.addEventListener('sealsubs:price_update', (event) => {
        if (!sealEventBelongsToForm(event) || !Number.isFinite(Number(event.detail?.price))) return;
        const currentPrice = Number(event.detail.price);
        selectedPrice.textContent = money(currentPrice);
        if (dockPrice) dockPrice.textContent = money(currentPrice);
      });

      form.addEventListener('submit', (event) => {
        flushVariantChange();
        formError.hidden = true;
        syncPreorderProperty();
        if (!variantInput.value) {
          event.preventDefault();
          formError.textContent = 'Please choose an available size.';
          formError.hidden = false;
          return;
        }
        const liveSellingPlanInput = form.querySelector('.bto-seal-slot input[name="selling_plan"], input[data-sls-selling_plan][name="selling_plan"]');
        if (purchaseType === 'subscription' && (!liveSellingPlanInput || !liveSellingPlanInput.value)) {
          event.preventDefault();
          formError.textContent = 'The subscription option is not available for this size.';
          formError.hidden = false;
        }
      }, { capture: true });

      const preorderFieldObserver = new MutationObserver(syncPreorderProperty);
      preorderFieldObserver.observe(form, { childList: true, subtree: true });

      // Reserve a separate bottom row for support/signup, using their rendered height.
      // ResizeObserver also handles larger text and either control being dismissed.
      const supportFloater = document.querySelector('.bto-guide-floater') || document.querySelector('.bto-guide-launcher');
      const floatingControls = [supportFloater, document.querySelector('.bt-welcome-tab')].filter(Boolean);
      const syncFloatingClearance = () => {
        const height = Math.ceil(Math.max(0, ...floatingControls.map(control => control.getBoundingClientRect().height)));
        dock?.style.setProperty('--bto-mobile-floating-height', `${height}px`);
      };
      if (dock && floatingControls.length) {
        if ('ResizeObserver' in window) {
          const floatingResizeObserver = new ResizeObserver(syncFloatingClearance);
          floatingControls.forEach(control => floatingResizeObserver.observe(control));
        }
        window.addEventListener('resize', syncFloatingClearance, { passive: true });
        syncFloatingClearance();
      }
      if (addButton && floatingControls.length) {
        const purchaseButtonObserver = new IntersectionObserver(([entry]) => {
          floatingControls.forEach(control => control.toggleAttribute('data-bto-buy-button-visible', entry.isIntersecting));
        });
        purchaseButtonObserver.observe(addButton);
      }

      const dockStorageKey = `bto-product-dock-dismissed:${productHandle}`;
      let dockDismissed = window.sessionStorage.getItem(dockStorageKey) === 'true';
      let dockObserver;
      if (dockDismissed) dock?.classList.add('is-dismissed');

      dockSubmit?.addEventListener('click', () => form.requestSubmit(addButton));
      dock?.querySelector('[data-dock-close]')?.addEventListener('click', () => {
        dockDismissed = true;
        window.sessionStorage.setItem(dockStorageKey, 'true');
        dock.classList.add('is-dismissed');
        dock.hidden = true;
        dockObserver?.disconnect();
        dock.remove();
      });
      const purchasePanel = root.querySelector('#bto-buy');
      if (dock && purchasePanel && !dockDismissed) {
        dockObserver = new IntersectionObserver(([entry]) => {
          if (dockDismissed) return;
          dock.hidden = !(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
        dockObserver.observe(purchasePanel);
      }

      updatePurchase();
    }

    const pairingCards = [...root.querySelectorAll('[data-pairing]')];
    if (pairingCards.length) {
      const name = root.querySelector('[data-pairing-name]');
      const kicker = root.querySelector('[data-pairing-kicker]');
      const link = root.querySelector('[data-pairing-link]');
      const linkName = root.querySelector('[data-pairing-link-name]');
      pairingCards.forEach((card) => card.addEventListener('click', () => {
        pairingCards.forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
          const control = item.querySelector('.bto-pairing-copy > u');
          if (control) control.innerHTML = selected ? 'Selected <b aria-hidden="true">✓</b>' : 'Choose this duo <b aria-hidden="true">+</b>';
        });
        name.textContent = card.dataset.companion;
        kicker.textContent = card.dataset.kicker;
        link.href = card.dataset.url;
        linkName.textContent = card.dataset.companion;
      }));
    }

    const liveReviewWidget = root.querySelector('.zegsu-reviews');
    if (liveReviewWidget) {
      const polishLiveReviewFeed = () => {
        const title = liveReviewWidget.querySelector('.zegsu-review-form-title');
        if (title && title.textContent.trim() !== 'All customer reviews') title.textContent = 'All customer reviews';

        const ratingText = (liveReviewWidget.querySelector('.zegsu-review-number-total-review span')?.textContent || '').replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
        const ratingValue = /^\d+(?:\.\d+)?$/.test(ratingText) ? Number(ratingText) : NaN;
        const hasRating = Number.isFinite(ratingValue) && ratingValue >= 1 && ratingValue <= 5;
        const rating = hasRating ? ratingText : null;
        const counts = [...liveReviewWidget.querySelectorAll('.alr-count')]
          .map((element) => Number(element.textContent.replace(/[^0-9]/g, '')))
          .filter((value) => Number.isFinite(value));
        const reviewCount = counts.reduce((total, value) => total + value, 0);
        if (reviewCount > 0 && hasRating) {
          root.querySelectorAll('[data-live-review-count]').forEach((element) => {
            element.textContent = element.dataset.liveReviewCount === 'number' ? String(reviewCount) : `${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`;
          });
          const summary = root.querySelector('[data-review-summary]');
          if (summary) {
            summary.setAttribute('aria-label', `Rated ${rating} out of 5 based on ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`);
            if (summary.classList.contains('bto-rating--new')) {
              summary.classList.remove('bto-rating--new');
              summary.insertAdjacentHTML('afterbegin', '<span aria-hidden="true" data-live-review-stars></span>');
            }
          }
          const stars = summary?.querySelector('span[aria-hidden="true"]');
          if (stars) {
            const filled = Math.round(ratingValue);
            stars.textContent = '★'.repeat(filled) + '☆'.repeat(5 - filled);
          }
          const productSchema = root.querySelector('[data-product-schema]');
          if (productSchema) {
            try {
              const schema = JSON.parse(productSchema.textContent);
              schema.aggregateRating = schema.aggregateRating || { '@type': 'AggregateRating' };
              schema.aggregateRating.reviewCount = String(reviewCount);
              schema.aggregateRating.ratingValue = rating;
              productSchema.textContent = JSON.stringify(schema);
            } catch (_) {
              // Keep the server-rendered fallback if an app changes the schema block.
            }
          }
        }
        if (reviewCount > 0 && hasRating) root.querySelectorAll('[data-live-review-rating]').forEach((element) => { element.textContent = rating; });
      };
      polishLiveReviewFeed();
      const liveReviewObserver = new MutationObserver(polishLiveReviewFeed);
      liveReviewObserver.observe(liveReviewWidget, { childList: true, subtree: true });
    }

    // Ask Bella is initialized by the shared bto-ai-guide.js asset.

    root.querySelectorAll('.bto-mobile-menu a').forEach((link) => link.addEventListener('click', () => {
      link.closest('details')?.removeAttribute('open');
    }));
  });
})();
